<template>
  <div class="h-full">
    <div class="h-full flex flex-col gap-y-2 lg:gap-y-4">
      <div class="flex items-center lg:h-9">
        <div class="w-full flex flex-col-reverse justify-between gap-3 lg:flex-row lg:items-center">
          <ul class="flex items-center gap-x-2">
            <li>
              <GrmSimpleSelect
                  :value="testbankExamHistoryListFilter.examType"
                  :options="[
                    { value: '', title: $t('common.all') },
                    { value: 'QUIZ', title: $t('common.quiz') },
                    { value: 'SURVEY', title: $t('common.survey') },
                  ]"
                  @input="(value) => SET_TESTBANK_EXAM_HISTORY_LIST_FILTER({ examType: value })"
              />
            </li>
            <li>
              <GrmSimpleSelect
                  :value="testbankExamHistoryListFilter.size"
                  :options="[
                    { value: 10, title: $t('common.table.count.ten') },
                    { value: 20, title: $t('common.table.count.twenty') },
                    { value: 30, title: $t('common.table.count.thirty') },
                    { value: 40, title: $t('common.table.count.forty') },
                    { value: 50, title: $t('common.table.count.fifty') },
                  ]"
                  @input="(value) => SET_TESTBANK_EXAM_HISTORY_LIST_FILTER({ size: value })"
              />
            </li>
            <li>
              <GrmCheckbox id="inThisRoom"
                           :value="testbankExamHistoryListFilter.inThisRoom"
                           @input="(value) => SET_TESTBANK_EXAM_HISTORY_LIST_FILTER({ inThisRoom: value })"
              >{{ $t("testBank.onlyThisRoom") }}</GrmCheckbox>
            </li>
          </ul>
          <GrmSearch :value="testbankExamHistoryListFilter.examTitle"
                     class="w-full lg:w-60"
                     ref="search"
                     @input="(value) => SET_TESTBANK_EXAM_HISTORY_LIST_FILTER({ examTitle: value })"
                     @clear="() => {
                        SET_TESTBANK_EXAM_HISTORY_LIST_FILTER({ examTitle: '' });
                        $refs.search.$refs.search.focus();
                     }"
          />
        </div>
      </div>
      <div class="min-h-0 flex-1">
        <RoomTestbankHistoryListTable />
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import {debounce} from "lodash";

import GrmSearch from "@/components/Common/search/GrmSearch.vue";
import GrmCheckbox from "@/components/Common/input/GrmCheckbox.vue";
import GrmSimpleSelect from "@/components/Common/select/GrmSimpleSelect.vue";
import RoomTestbankHistoryListTable from "@/components/Room/Testbank/History/RoomTestbankHistoryListTable.vue";

export default {
  name: 'RoomTestbankHistoryList',
  components: {
    GrmSearch,
    GrmCheckbox,
    GrmSimpleSelect,
    RoomTestbankHistoryListTable
  },
  computed: {
    ...mapState('testbank', [
      'testbankExamHistoryListFilter',
    ]),
  },
  watch: {
    testbankExamHistoryListFilter: {
      handler() {
        this._getTestbankExamHistoryList();
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations('testbank', [
      'SET_TESTBANK_EXAM_HISTORY_LIST_FILTER',
    ]),
    ...mapActions('testbank', [
      'getTestbankExamHistoryList',
    ]),

    _getTestbankExamHistoryList: debounce(function () {
      this.getTestbankExamHistoryList();
    }, 200, {
      leading: false,
      trailing: true,
    }),
  }
}
</script>